<template><section><h2>Basic Column Chart 基础柱状图</h2>
<block-demo tip="" source="const data = [
  { value: 22, label: &quot;05-01&quot; },
  { value: 60, label: &quot;05-02&quot; },
  { value: 56, label: &quot;05-03&quot; },
  { value: 85, label: &quot;05-04&quot; },
  { value: 136, label: &quot;05-05&quot; },
  { value: 108, label: &quot;05-06&quot; },
  { value: 64, label: &quot;05-07&quot; },
  { value: 35, label: &quot;05-08&quot; },
]
const { Chart, Bar, Tooltip, Axis, Legend } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  value: &quot;value&quot;,
  text: &quot;label&quot;,
})
const bar = new Bar({
  animation: {
    duration: 1000,
    easing: &quot;elasticOut&quot;,
  },
})
const tooltip = new Tooltip()
const axisBottom = new Axis().style(&quot;grid&quot;, false)
const axisLeft = new Axis({ orient: &quot;left&quot; })
  .style(&quot;axis&quot;, false)
  .style(&quot;scale&quot;, false)
chart.append([bar, tooltip, axisBottom, axisLeft])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">value</span>: <span class="hljs-number">22</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-01"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">60</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-02"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">56</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-03"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">85</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-04"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">136</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-05"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">108</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-06"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">64</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-07"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">35</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"05-08"</span> },
]
<span class="hljs-keyword">const</span> { Chart, Bar, Tooltip, Axis, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">value</span>: <span class="hljs-string">"value"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"label"</span>,
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> Bar({
  <span class="hljs-attr">animation</span>: {
    <span class="hljs-attr">duration</span>: <span class="hljs-number">1000</span>,
    <span class="hljs-attr">easing</span>: <span class="hljs-string">"elasticOut"</span>,
  },
})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis().style(<span class="hljs-string">"grid"</span>, <span class="hljs-literal">false</span>)
<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">"left"</span> })
  .style(<span class="hljs-string">"axis"</span>, <span class="hljs-literal">false</span>)
  .style(<span class="hljs-string">"scale"</span>, <span class="hljs-literal">false</span>)
chart.append([bar, tooltip, axisBottom, axisLeft])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>